import debounce from 'lodash/debounce'
import { useMemo } from 'react'

export function useDebounced(fn, time = 50, options = {}) {
    return useMemo(() => {
        return debounce(fn, time, options)
    }, options.dependencies || [])
}
